import { useEffect, useState, useCallback } from "react";
import apiClient from "../api/apiClient";
import apiPaths from "../api/endpoints";

interface UseSchoolHierarchyParams {
  schoolHash: string;
  enabled:boolean;
}

export function useSchoolHierarchy({ schoolHash,enabled=true }: UseSchoolHierarchyParams) {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSchoolHierarchy = useCallback(async () => {
      if (!schoolHash || !enabled) return;

    try {
      setLoading(true);
      setError(null);

      const res = await apiClient.get(apiPaths.SCHOOL_DETAIL, {
        params: { schoolHash },
      });

      setData(res.data);
    } catch (err: any) {
      console.error("School Hierarchy API error:", err);
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  }, [schoolHash,enabled]);

  useEffect(() => {
    fetchSchoolHierarchy();
  }, [fetchSchoolHierarchy]);

  return {
    data,
    loading,
    error,
    refetch: fetchSchoolHierarchy,
  };
}
